/**
 * A ranked list with proportional bars — lighter than a full chart for "top
 * N by value", and reads better at this size than a bar chart would with
 * long medicine names on the axis.
 */
export function RankedBarList({
  items,
  color = '#FF6B4D',
}: {
  items: Array<{ label: string; value: number; sublabel?: string }>;
  color?: string;
}) {
  if (items.length === 0) {
    return <p className="py-8 text-center text-sm text-muted-foreground">Nothing to show yet.</p>;
  }

  const max = Math.max(...items.map((i) => i.value), 1);

  return (
    <div className="space-y-2.5">
      {items.map((item, index) => (
        <div key={`${item.label}-${index}`}>
          <div className="mb-1 flex items-baseline justify-between gap-2 text-xs">
            <span className="truncate font-medium">{item.label}</span>
            <span className="tabular shrink-0 text-muted-foreground">
              {item.sublabel ?? item.value.toLocaleString('en-IN')}
            </span>
          </div>
          <div className="h-1.5 overflow-hidden rounded-full bg-secondary">
            <div
              className="h-full rounded-full transition-all"
              style={{ width: `${(item.value / max) * 100}%`, backgroundColor: color }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}